module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"selectFilter":"Filter by trigger context","maximum":"5 filter maximum","filterAutomation":"Filter automation"}}')
  delete Component.options._Ctor
}
